import { createAsyncThunk } from '@reduxjs/toolkit';

import { SHOPIFY_CHANNEL_TYPE } from '../../components/teammates/views/Channels/helpers/salesChannelState';

export const resetPendingSalesChannel = createAsyncThunk(
  'salesChannels/resetPendingSalesChannel',
  async (_, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.resetSalesChannel({
        type: SHOPIFY_CHANNEL_TYPE,
      });
      return data;
    } catch (error) {
      Logger.error(
        new Error('Reset pending sales channel failed'),
        { error },
        ['ConnectShopifyChResetPendingFailed', {}],
      );
      throw error;
    }
  },
);
